const e = "_segment_u5aqy_1", s = "_blue_u5aqy_77", t = "_white_u5aqy_80", _ = "_segmensTablist_u5aqy_83", n = {
  segment: e,
  blue: s,
  white: t,
  segmensTablist: _
};
export {
  s as blue,
  n as default,
  _ as segmensTablist,
  e as segment,
  t as white
};
//# sourceMappingURL=segments.module.less.js.map
